/**
 * Add to an array if it's not already in the array.\
 * Warning: This will modify the original array.
 *
 * @typeParam T - The array item type (infered)
 *
 * @param array Array to add to
 * @param toAdd Item to add to array
 * @returns Array with item added if it wasn't already in the array
 *
 * @example
 * const array = [1, 2, 3];
 * addToArrayUnique(array, 3); // [1, 2, 3]
 * addToArrayUnique(array, 4); // [1, 2, 3, 4]
 */
export const addToArrayUnique = <T>(array: T[], toAdd: T) => {
	if (!array.includes(toAdd)) array.push(toAdd);
	return array;
};
